import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getCurrentPatternId } from '../../reducers/currentPattern';
import { getCurrentPriceActionLabel, getMessage } from '../../reducers/i18n';
import {
    getCurrentPriceActionEndDate,
    getSchnoffPrice,
    getStrikeThroughPrice,
    isShippingFree,
} from '../../reducers/prices';
import Heading from '../heading/Heading';

import ShippingCostDialog from './ShippingCostDialog';

const vatPriceSuffix = (
    <FormattedMessage
        id='VAT_PRICE_SUFFIX'
        description='Prices Suffix for prices including vat.'
        defaultMessage='inkl. 19% USt.'
    />
);

const shippingCostLabel = (
    <FormattedMessage
        id='SHIPPING_COST_LABEL'
        description='Label for the shipping cost modal'
        defaultMessage='Versandkosten'
    />
);

const shippingCostLabelPrefix = (
    <FormattedMessage
        id='SHIPPING_COST_LABEL_PREFIX'
        description='Prefix for the shipping cost label'
        defaultMessage='zzgl.'
    />
);

const messages = defineMessages({
    cartButton: {
        id: 'CART_BUTTON_LABEL',
        description: 'Message for the cart button.',
        defaultMessage: 'einpacken',
    },
    shippingCostIncludedLabel: {
        id: 'SHIPPING_INCLUDED_LABEL',
        description: 'Label for the shipping cost iluded.',
        defaultMessage: 'inkl. Versandkosten',
    },
    currentPriceActionLabel: {
        id: 'CURRENT_PRICE_ACTION_LABEL',
        description: 'Label for the current price action',
        defaultMessage: '% Einführungspreis (bis {date}) %',
    },
    shippingFreeLabel: {
        id: 'SHIPPING_FREE_PRICE_ACTION_LABEL',
        description: 'Label for shipping free price action.',
        defaultMessage: 'Versandkostenfrei DE (bis {date})',
    },
});

const PriceDisplay = props => {
    const StyledPaper = styled(Paper)`
        &.stolo-price-display {
            background-color: #F4DECB;
            padding: ${props => props.theme.space[3]};
            border-radius: 2px;
        }
    `;

    const PriceActionName = styled.div`
        &.stolo-price-action-label {
            color: ${props => props.theme.palette.secondary.main};
            font-size: 0.75rem;
            margin-bottom: 0.15em;
            text-align: right;
        }
    `;

    const PriceDisplay = styled.div`
        text-align: right;
        font-weight: 600;
        margin-right: ${props => props.theme.space[6]};
    `;

    const PriceSuffix = styled.div`
        display: flex;
        font-size: ${props => props.theme.fontSizes[7]};
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-end;
        
        & button {
          box-sizing: border-box;
          text-transform: none;
          padding: ${props => props.theme.space[3]};
          min-height: inherit;
        }

        & .stolo-price-suffix {
          padding: ${props => props.theme.space[2]} 0;
        }

    `;

    const StrikeThroughPrice = styled.div`
        text-align: right;
        font-weight: 600;
        position: relative;
        display: inline-block;
        color: ${props => props.theme.palette.blueGrey[600]};

        &::before {
          content: '';
          width: 100%;
          position: absolute;
          right: 0;
          top: 50%;
        }
        
        &::before {
          border-bottom: 1px solid ${
        props => props.theme.palette.secondary[500]};
          transform: skewY(-10deg);
        }
`;

    const StyledDialogHeader = styled(Heading)`
        margin: 0;
        padding: 0;
    `;

    const DialogHeader = (
        <StyledDialogHeader
            level={2}
            text={shippingCostLabel}
        />
    );

    const priceSuffix = [
        <PriceSuffix key='s1'>
            <div
                className='stolo-price-suffix'
                key='s2'
            >{vatPriceSuffix} {shippingCostLabelPrefix}</div>
            : <ShippingCostDialog
                key='s3' className='stolo-price-suffix'
                label={shippingCostLabel} header={DialogHeader}
                close={props.labelClose}
            />
        </PriceSuffix>];

    const image = `https://d2k02hhj0n6fcf.cloudfront.net/patterns/de/${props.patternid}.png`;
    const image2 = `https://d1biw2rz2h5h5w.cloudfront.net/images/patterns/api/detail/xlarge/${props.patternid}.png`;

    return (

        <React.Fragment>
            <StyledPaper
                elevation={2}
                classes={{ root: 'stolo-price-display' }}
            >
                <PriceDisplay>
                    {props.amount.toFixed(2)} {props.currencyUnit}
                </PriceDisplay>
                {priceSuffix}
                <meta itemProp='priceCurrency' content='EUR' />
                <meta
                    itemProp='availability'
                    itemType='http://schema.org/ItemAvailability'
                    content='http://schema.org/InStock'
                />
                <meta itemProp='price' content={props.amount.toFixed(2)} />
                <meta itemProp='sku' content={props.patternid} />
                <meta itemProp='image' content={image} />
                <meta itemProp='image' content={image2} />
            </StyledPaper>
        </React.Fragment>
    );
};

PriceDisplay.propTypes = {
    currencyUnit: PropTypes.string,
    amount: PropTypes.number,
};

PriceDisplay.defaultProps = {
    currencyUnit: '€',
    amount: 999.99,
};

const mapStateToProps = state => {
    const strikeThroughPrice = getStrikeThroughPrice(state);
    const showStrikeThrough = !isShippingFree(state);
    return (
    {
        amount: parseFloat(getSchnoffPrice(state)),
        showStrikeThrough,
        strikeThrough: strikeThroughPrice
                    ? parseFloat(strikeThroughPrice)
                    : null,
        labelClose: getMessage(state, 'LABEL_CLOSE'),
        patternid: getCurrentPatternId(state),
        message: getCurrentPriceActionLabel(state),
        endDate: getCurrentPriceActionEndDate(state),
    }

    );
}
;

export default connect(mapStateToProps)(injectIntl(PriceDisplay));



// WEBPACK FOOTER //
// ./src/components/addtocart/PriceDisplay.js